<template>
    <div class="news" id="news">
        <div class="mobiletopbox hidden-sm-and-up">
            <div class="mobiletopbox_top">
                <div class="navigation">
                    <div class="navigation_location"></div>
                    <div class="navigation_index" @click="goIndex">首页</div>
                    <div class="navigation_img"></div>
                        <div class="navigation_text">联系我们</div>
                </div>
            </div>
        </div>
        <div class="news_box section">
            <div class="news_right" v-loading="loading">
                <div class="news_right_top hidden-xs-only">
                    <div class="navigation">
                        <div class="navigation_location"></div>
                        <div class="navigation_text">当前所在位置：</div>
                        <div class="navigation_index" @click="goIndex">首页</div>
                        <div class="navigation_img"></div>
                        <div class="navigation_text">联系我们</div>
                    </div>
                </div>
                <div class="news_right_middle">
                    <div class="news_right_middle_left">
                        <img src="../assets/images/contact/tip.png" alt="">
                    </div>
                    <div class="news_right_middle_right">友情提示：扫描二维码添加微信好友时请备注企业名称</div>
                </div>
                <div class="news_right_bottom">
                    <div class="news_right_bottom_box" v-if="contracList.length>0">
                        <div class="news_right_bottom_item" v-for="(item,index) in contracList" :key="index">
                            <div class="news_right_bottom_item_left">
                                <div class="news_right_bottom_item_left_top">{{item.dept}}</div>
                                <div class="news_right_bottom_item_left_bottom">
                                    <div class="news_right_bottom_item_left_bottom_box">
                                        <div class="news_right_bottom_item_left_bottom_item">
                                            <div class="news_right_bottom_item_left_bottom_item_left">
                                                <img src="../assets/images/contact/realName.png" alt="">
                                            </div>
                                            <div class="news_right_bottom_item_left_bottom_item_right">
                                                <div class="news_right_bottom_item_left_bottom_item_right_top">负责人</div>
                                                <div class="news_right_bottom_item_left_bottom_item_right_bottom">{{item.leader}}</div>
                                            </div>
                                        </div>
                                        <div class="news_right_bottom_item_left_bottom_item">
                                            <div class="news_right_bottom_item_left_bottom_item_left">
                                                <img src="../assets/images/contact/phone.png" alt="">
                                            </div>
                                            <div class="news_right_bottom_item_left_bottom_item_right">
                                                <div class="news_right_bottom_item_left_bottom_item_right_top">咨询热线</div>
                                                <div class="news_right_bottom_item_left_bottom_item_right_bottom">{{item.phone}}</div>
                                            </div>
                                        </div>
                                        <div class="news_right_bottom_item_left_bottom_item">
                                            <div class="news_right_bottom_item_left_bottom_item_left">
                                                <img src="../assets/images/contact/email.png" alt="">
                                            </div>
                                            <div class="news_right_bottom_item_left_bottom_item_right">
                                                <div class="news_right_bottom_item_left_bottom_item_right_top">企业邮箱</div>
                                                <div class="news_right_bottom_item_left_bottom_item_right_bottom">{{item.email}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="news_right_bottom_item_right">
                                <div class="news_right_bottom_item_right_box" v-if="item&&item.qr">
                                    <img :src="baseUrl+item.qr" alt="">
                                </div>
                                <img class="none_img" v-else src="../assets/images/index/img_none.png" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="news_right_bottom_none" v-if="contracList.length == 0">暂无数据</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { contractPage } from '../untils/common-api.js'
export default {
    data() {
        return {
            baseUrl: process.env.VUE_APP_BASE_URL,
            loading: false,
            total: null,
            query: {
                current: 1,
                pageSize: -1,
                type: 1,
                lang:1
            },
            contracList: []
        }
    },
    created() {
        this.getContractPage()
    },
    mounted() {
        this.getScrollTop()
    },
    methods:{
        // 获取新闻列表
        async getContractPage() {
            this.loading = true // loading start
            let res = await contractPage(this.query)
            this.loading = false // loading end
            if (res.code !== 1) return this.$message('信息获取失败，请稍后重试')
            this.total = res.data.total
            this.contracList = res.data.records
        },
        goIndex() {
            this.$router.push('/index')
        },
        getScrollTop() {
            let div = document.getElementById('news');
            if (div) {
                setTimeout(function () {
                    $('html, body').animate({scrollTop: 0}, 0)
                }, 0);
            }
        },
    },
}
</script>
<style lang="less" scoped>
.news {
    background-color: #f6f9ff;
    padding: 30px 0 60px 0;
    .news_box {
        .news_right {
            width: 100%;
            .news_right_middle {
                height: 80px;
                display: flex;
                align-items: center;
                .news_right_middle_left {
                    margin-right: 10px;
                    img {
                        width: 20px;
                        height: 20px;
                    }
                }
                .news_right_middle_right {
                    font-size: 18px;
                    color: #0085D0;
                }
            }
            .news_right_bottom {
                .news_right_bottom_box {
                    .news_right_bottom_item {
                        padding: 35px;
                        background-color: #ffffff;
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: 20px;
                        .news_right_bottom_item_left {
                            width: calc(100% - 200px);
                            .news_right_bottom_item_left_top {
                                font-size: 26px;
                                font-weight: bold;
                                margin-bottom: 40px;
                            }
                            .news_right_bottom_item_left_bottom {
                                .news_right_bottom_item_left_bottom_box {
                                    display: flex;
                                    .news_right_bottom_item_left_bottom_item {
                                        display: flex;
                                        .news_right_bottom_item_left_bottom_item_left {
                                            margin-right: 10px;
                                            img {
                                                width: 20px;
                                                height: 20px;
                                            }
                                        }
                                        .news_right_bottom_item_left_bottom_item_right {
                                            .news_right_bottom_item_left_bottom_item_right_top {
                                                font-size: 18px;
                                                color: #787878;
                                                margin-bottom: 15px;
                                            }
                                            .news_right_bottom_item_left_bottom_item_right_bottom {
                                                font-size: 22px;
                                                font-weight: bold;
                                            }
                                        }
                                    }
                                    .news_right_bottom_item_left_bottom_item:nth-child(1) {
                                        width:15%;
                                    }
                                    .news_right_bottom_item_left_bottom_item:nth-child(2) {
                                        margin: 0 110px;
                                    }
                                    .news_right_bottom_item_left_bottom_item:nth-child(3) {
                                        .news_right_bottom_item_left_bottom_item_left {
                                            img {
                                                width: 23px;
                                                height: 20px;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        .news_right_bottom_item_right {
                            width: 200px;
                            height: 156px;
                            display: flex;
                            flex-direction: row-reverse;
                            .news_right_bottom_item_right_box {
                                width: 156px;
                                height: 156px;
                                border: 1px solid #e3e3e3;
                                border-radius: 12px;
                                padding: 4px;
                                img {
                                    max-width: 148px;
                                    max-height: 148px;
                                    object-fit: contain;
                                }
                            }
                            .none_img {
                                max-height: 100%;
                                object-fit: contain;
                            }
                        }
                    }
                    .news_right_bottom_item:last-child {
                        margin-bottom: 0;
                    }
                }
                .news_right_bottom_none {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: #ffffff;
                    min-height: 200px;
                    font-size: 16px;
                }
            }
        }
    }
}
@media (max-width: 768px) {
    .news {
        padding: 0.3rem 0 0.6rem 0;
        .news_box {
            .news_right {
                .news_right_middle {
                    height: 1.4rem;
                    .news_right_middle_left {
                        width: 0.4rem;
                        margin-right: 0.1rem;
                        img {
                            width: 0.4rem;
                            height: 0.4rem;
                        }
                    }
                    .news_right_middle_right {
                        width: calc(100% - 0.4rem - 0.1rem);
                        font-size: 0.3rem;
                    }
                }
                .news_right_bottom {
                    .news_right_bottom_box {
                        .news_right_bottom_item {
                            flex-direction: column;
                            padding: 0.3rem;
                            margin-bottom: 0.2rem;
                            .news_right_bottom_item_left {
                                width: 100%;
                                .news_right_bottom_item_left_top {
                                    font-size: 0.4rem;
                                    margin-bottom: 0.4rem;
                                    text-align: center;
                                }
                                .news_right_bottom_item_left_bottom {
                                    display: flex;
                                    justify-content: center;
                                    .news_right_bottom_item_left_bottom_box {
                                        flex-direction: column;
                                        .news_right_bottom_item_left_bottom_item {
                                            display: flex;
                                            margin-bottom: 0.2rem;
                                            .news_right_bottom_item_left_bottom_item_left {
                                                margin-right: 0.2rem;
                                                img {
                                                    width: 0.4rem;
                                                    height: 0.4rem;
                                                }
                                            }
                                            .news_right_bottom_item_left_bottom_item_right {
                                                .news_right_bottom_item_left_bottom_item_right_top {
                                                    font-size: 0.3rem;
                                                    margin-bottom: 0.05rem;
                                                }
                                                .news_right_bottom_item_left_bottom_item_right_bottom {
                                                    font-size: 0.32rem;
                                                }
                                            }
                                        }
                                        .news_right_bottom_item_left_bottom_item:nth-child(2) {
                                            margin: 0 0;
                                            margin-bottom: 0.2rem;
                                        }
                                        .news_right_bottom_item_left_bottom_item:nth-child(1) {
                                            width:100%;
                                        }
                                        .news_right_bottom_item_left_bottom_item:nth-child(3) {
                                            .news_right_bottom_item_left_bottom_item_left {
                                                img {
                                                    width: 0.4rem;
                                                    height: 0.36rem;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            .news_right_bottom_item_right {
                                margin-top: .1rem;
                                width: 100%;
                                height: 2.8rem;
                                justify-content: center;
                                .news_right_bottom_item_right_box {
                                    width: 2.8rem;
                                    height: 2.8rem;
                                    border-radius: 0.12rem;
                                    padding: 0.06rem;
                                    img {
                                        max-width: 2.6rem;
                                        max-height: 2.6rem;
                                    }
                                }
                            }
                        }
                    }
                    .news_right_bottom_none {
                        min-height: 3rem;
                        font-size: 0.3rem;
                    }
                }
            }
        }
    }

}

</style>